import { FaTimes } from "react-icons/fa";

const PALETTE = ["#1F2937", "#1D4ED8", "#0F766E", "#B45309", "#B91C1C", "#FFFFFF"];

function EditorPageProperties({ pageStyle, onChange, onClose, modal = false }) {
    const updatePageStyle = changes => onChange({ ...pageStyle, ...changes });

    return (
        <section
            className="editor-page-properties"
            role="dialog"
            aria-modal={modal}
            aria-labelledby="editor-page-properties-title"
        >
            <header className="editor-floating-panel-header">
                <h2 id="editor-page-properties-title">Propiedades de hoja</h2>
                <button type="button" aria-label="Cerrar propiedades de hoja" onClick={onClose}>
                    <FaTimes aria-hidden="true" />
                </button>
            </header>
            <div className="editor-page-properties-body">
                <div className="property-group">
                    <label htmlFor="page-background-color">Color de fondo</label>
                    <div className="color-control-row">
                        <input
                            id="page-background-color"
                            type="color"
                            value={pageStyle.backgroundColor}
                            onChange={event => updatePageStyle({ backgroundColor: event.target.value })}
                        />
                        <span>{pageStyle.backgroundColor.toUpperCase()}</span>
                    </div>
                </div>
                <div className="property-group">
                    <label>Paleta de hoja</label>
                    <div className="color-palette">
                        {PALETTE.map(color => (
                            <button
                                key={color}
                                type="button"
                                className="color-swatch"
                                style={{ backgroundColor: color }}
                                aria-label={`Fondo de hoja ${color}`}
                                onClick={() => updatePageStyle({ backgroundColor: color })}
                            />
                        ))}
                    </div>
                </div>
                <div className="property-group">
                    <label htmlFor="page-texture">Textura</label>
                    <select
                        id="page-texture"
                        value={pageStyle.texture}
                        onChange={event => updatePageStyle({ texture: event.target.value })}
                    >
                        <option value="plain">Lisa</option>
                        <option value="dots">Puntos</option>
                        <option value="lines">Líneas</option>
                        <option value="diagonal">Diagonal</option>
                    </select>
                </div>
            </div>
        </section>
    );
}

export default EditorPageProperties;
